import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

const PILLARS = [
    "Enterprise Networking",
    "B2B IT Solutions",
    "Educational Institutions",
    "Government Projects",
    "Data Centers",
    "Structured Cabling",
    "Fiber Optic Solutions",
    "Annual Maintenance Contracts (AMC)",
    "Network Security",
    "IT Infrastructure Consulting",
];

export default function About() {
    return (
        <section id="about" className="py-20 lg:py-28 bg-white" data-testid="about-section">
            <div className="container-lg">
                <div className="grid lg:grid-cols-12 gap-12 items-start">
                    <motion.div
                        className="lg:col-span-5"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.6 }}
                    >
                        <span className="text-xs font-bold tracking-[0.24em] uppercase text-brand">About CoreCyrus</span>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy leading-tight">
                            A trusted networking partner for<br />modern enterprises.
                        </h2>
                        <p className="mt-6 text-slate-600 leading-relaxed">
                            CoreCyrus is a full-stack networking and IT infrastructure company delivering
                            design, procurement, installation, and long-term support for businesses,
                            campuses, data centers and government projects across India. From single-site
                            rollouts to multi-branch fabric networks, our certified engineers turn
                            complex requirements into resilient, secure and future-ready deployments.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4">
                                <div className="font-display text-2xl font-extrabold text-navy">10+ yrs</div>
                                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">Field Experience</div>
                            </div>
                            <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4">
                                <div className="font-display text-2xl font-extrabold text-navy">Nationwide</div>
                                <div className="text-xs uppercase tracking-wider text-slate-500 mt-1">On-site service</div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        className="lg:col-span-7"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <div className="grid sm:grid-cols-2 gap-3">
                            {PILLARS.map((p, i) => (
                                <div
                                    key={p}
                                    data-testid={`about-pillar-${i}`}
                                    className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3.5 hover:border-brand/40 hover:bg-brand-soft/30 transition-colors"
                                >
                                    <CheckCircle2 className="w-5 h-5 text-brand mt-0.5 shrink-0" />
                                    <span className="text-sm font-medium text-navy">{p}</span>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
